/* eslint-disable react-hooks/exhaustive-deps, array-bracket-newline */
import React, { useState } from 'react';
import { LS_BIG_TRADES_KEY } from './BigTradesTable';

interface ITableWidths {
  ticker: number;
  time: number;
  type: number;
  baseAmount: number;
  quoteAmount: number;
  priceUSD: number;
  valueUSD: number;
  wallet: number;
}

// constants
const tableWidthsDefaultState: ITableWidths = {
  ticker: 150,
  time: 130,
  type: 130,
  baseAmount: 150,
  quoteAmount: 130,
  priceUSD: 130,
  valueUSD: 150,
  wallet: 150,
};

interface IUseTableDataProps {
  trades: any;
}

const useBigTradesTableData = ({ trades }: IUseTableDataProps) => {
  const tableWidthsLC = localStorage.getItem(LS_BIG_TRADES_KEY);

  const [tableColumnsWidth] = useState(
    tableWidthsLC ? JSON.parse(tableWidthsLC) : tableWidthsDefaultState
  );

  // table memoized required fields
  const data = React.useMemo(() => trades, [trades]);
  const columns = React.useMemo(
    () => [
      {
        id: 'ticker',
        Header: 'Pair',
        accessor: 'ticker',
        disableSortBy: true,
        width: tableColumnsWidth['ticker'] || tableWidthsDefaultState['ticker'],
      },
      {
        id: 'time',
        Header: 'Time',
        accessor: 'timestamp',
        disableSortBy: true,
        width: tableColumnsWidth['time'] || tableWidthsDefaultState['time'],
      },
      {
        id: 'type',
        Header: 'Type',
        accessor: 'buy',
        disableSortBy: true,
        width: tableColumnsWidth['type'] || tableWidthsDefaultState['type'],
      },
      {
        id: 'amount_base',
        Header: 'Amount Base',
        accessor: 'amount_base',
        disableSortBy: true,
        width:
          tableColumnsWidth['baseAmount'] ||
          tableWidthsDefaultState['baseAmount'],
      },
      {
        id: 'amount_quote',
        Header: 'Amount Quote',
        accessor: 'amount_quote',
        disableSortBy: true,
        width:
          tableColumnsWidth['quoteAmount'] ||
          tableWidthsDefaultState['quoteAmount'],
      },
      {
        id: 'price_usd',
        Header: 'Price USD',
        accessor: 'price_usd',
        disableSortBy: true,
        width:
          tableColumnsWidth['priceUSD'] || tableWidthsDefaultState['priceUSD'],
      },
      {
        id: 'value_usd',
        Header: 'Value',
        accessor: 'value_usd',
        width:
          tableColumnsWidth['valueUSD'] || tableWidthsDefaultState['valueUSD'],
      },
      {
        id: 'wallet',
        Header: 'Wallet',
        accessor: 'wallet',
        disableSortBy: true,
        width: tableColumnsWidth['wallet'] || tableWidthsDefaultState['wallet'],
      },
    ],
    []
  );

  return { columns, data, tableColumnsWidth };
};

export { useBigTradesTableData };
